export default __webpack_public_path__ + "static/media/img3.aa535f55.png";